/** @typedef {import('@/types/api').CustomerPackageProfile} CustomerPackageProfile */
/** @typedef {import('@/types/api').CustomerPackageRedemption} CustomerPackageRedemption */

import { api } from '@/lib/api'

/**
 * @param {number} customerId
 * @returns {Promise<CustomerPackageProfile[]>}
 */
export async function fetchCustomerPackageProfile(customerId) {
  const { data } = await api.get(`/masters/customers/${customerId}/packages`)
  return data.data.packages
}

/**
 * @param {number} customerId
 * @returns {Promise<CustomerPackageRedemption[]>}
 */
export async function fetchCustomerPackageRedemptions(customerId) {
  const { data } = await api.get(`/masters/customers/${customerId}/package-redemptions`)
  return data.data.redemptions
}

/**
 * @param {number} customerPackageId
 * @param {Record<string, unknown>} payload
 * @returns {Promise<import('@/types/api').CustomerPackageProfile>}
 */
export async function adjustCustomerPackage(customerPackageId, payload) {
  const { data } = await api.post(`/masters/customer-packages/${customerPackageId}/adjust`, payload)
  return data.data.package
}

export function formatCustomerPackageStatus(status) {
  switch (status) {
    case 'active':
      return 'Active'
    case 'exhausted':
      return 'Exhausted'
    case 'expired':
      return 'Expired'
    case 'cancelled':
      return 'Cancelled'
    default:
      return status
  }
}

export function formatCustomerPackageAmount(value) {
  const amount = Number(value)
  if (!Number.isFinite(amount)) return 'AED 0.00'
  return `AED ${amount.toFixed(2)}`
}

/**
 * @param {string | null | undefined} isoDate
 */
export function formatCustomerPackageDate(isoDate) {
  if (!isoDate) return '—'
  const date = new Date(isoDate)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleString()
}

/**
 * @param {CustomerPackageRedemption} redemption
 */
export function redemptionItemLabel(redemption) {
  return redemption.service_name
    ?? redemption.product_name
    ?? 'Redemption'
}
